/* global axios */
import ApiClient from './ApiClient';

class NotificationEmailConfigsAPI extends ApiClient {
  constructor() {
    super('notification_email_configs', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { notification_email_config: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { notification_email_config: data });
  }

  test(id) {
    return axios.post(`${this.url}/${id}/test`);
  }
}

export default new NotificationEmailConfigsAPI();
